import PropTypes from "prop-types";
import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import SectionTitleWithText from "../../components/section-title/SectionTitleWithText";
import BannerOne from "../../wrappers/banner/BannerOne";
import TextGridOne from "../../wrappers/text-grid/TextGridOne";
import FunFactOne from "../../wrappers/fun-fact/FunFactOne";
import TeamMemberOne from "../../wrappers/team-member/TeamMemberOne";
import BrandLogoSliderOne from "../../wrappers/brand-logo/BrandLogoSliderOne";
import FeatureIcon from "../../wrappers/feature-icon/FeatureIcon";

const About = ({ location }) => {
  const { pathname } = location;
  var strings = require("../../translations/italian.json");

  var informazioni = global.informazioni
  /*switch(global.aziendaID)
  {
    case 1: 
      informazioni = informazioniDGA
      break;
    case 2:
      informazioni = informazioniMondoCarta
      break;
  }*/
  return (
    
    <Fragment>
      <MetaTags>
        <title>{strings.chisiamo} | {informazioni.società}</title>
          <meta
            name="description"
            content= {strings.chisiamo + " " + informazioni.società}
          />
      </MetaTags>


      <LayoutOne>
        {/* breadcrumb */}
        <Breadcrumb />
        {global.aziendaID == 2 && <div style={{textAlign:"right", backgroundColor: "#063594", paddingRight: "20%", paddingTop: "2%", paddingBottom: "2%"}}><img height="95px" src = {informazioni.imageUnionCart} /></div>}
        {/* section title with text */}
        <SectionTitleWithText spaceTopClass="pt-100" spaceBottomClass="pb-95" />
        {global.aziendaID == 2 && <div style={{textAlign:"center"}}><img src = {informazioni.imageAbout} /></div>} 
        {/* banner */}
        <BannerOne spaceBottomClass="pb-70" />

        {/* text grid */}
        {/*<TextGridOne spaceBottomClass="pb-70" />*/}

        {/* fun fact */}
        {/*<FunFactOne
          spaceTopClass="pt-100"
          spaceBottomClass="pb-70"
          bgClass="bg-gray-3"
        />*/}
        <FeatureIcon spaceTopClass="pt-100" spaceBottomClass="pb-60" />
        
        {/* team member */}
        <TeamMemberOne spaceTopClass="pt-95" spaceBottomClass="pb-70" />

        {/* brand logo slider */}
        <BrandLogoSliderOne spaceBottomClass="pb-70" />
      </LayoutOne>
    </Fragment>
  );
};

About.propTypes = {
  location: PropTypes.object
};

export default About;
